import React, { useEffect, useState } from "react";
import { Dialog, Transition } from "@headlessui/react";
import { useDispatch, useSelector } from "react-redux";
import {
  hideCommercialModal,
  setFormData,
} from "./modalSlices/CommercialModalSlice";
import { fetchFloorMassComm } from "../property/propertySlice";

const CommercialModal = ({ onClose, dcode, srocode }) => {
  const dispatch = useDispatch();
  const show = useSelector((state) => state.CommercialModal.Commercialshow);
  const formData = useSelector((state) => state.CommercialModal.formData);

  const { floorMassCommOptions } = useSelector((state) => state.property);

  useEffect(() => {
    // Fetch floor mass residential data when modal opens
    dispatch(fetchFloorMassComm({ dcode, srocode }));
  }, [dcode, srocode]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    dispatch(setFormData({ [name]: value }));
  };

  const handleClose = () => {
    dispatch(hideCommercialModal());
    if (onClose) onClose();
  };

  const handleAddDetails = (e) => {
    e.preventDefault();
    console.log("Added data:", formData);
    handleClose(); // Close the modal after adding details
  };
  return (
    <Transition show={show} as={React.Fragment}>
      <Dialog
        as="div"
        className="fixed inset-0 overflow-y-auto"
        onClose={handleClose}
      >
        <div className="flex items-center justify-center min-h-screen">
          <div className="bg-gray-50 shadow-lg shadow-gray-300 overflow-hidden  max-w-xl w-full">
            <div className="px-4 py-5 sm:p-6">
              <h3 className="text-md font-medium mx-8 text-black mb-4">
                Residential / Agriculture Construction
              </h3>
              <form onSubmit={handleAddDetails}>
                <div className="space-y-4">
                  {/* Sub-Property Type */}
                  <div className="grid gap-4 m-8 sm:grid-cols-3 grid-cols-3 items-center text-sm">
                    <label
                      htmlFor="SubPropertyType"
                      className="block w-full relative text-sm font-semibold sm:col-span-1 grid-cols-1"
                    >
                      Sub-Property Type:
                    </label>
                    <div className="block w-full relative sm:col-span-2 col-span-2">
                      <select
                        id="SubPropertyType"
                        name="SubPropertyType"
                        value={formData.SubPropertyType}
                        onChange={handleChange}
                        className="block w-full pl-2 pr-8 py-1.5 border-none shadow-sm bg-gray-100 focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 text-sm"
                        required
                      >
                        {floorMassCommOptions.map((option) => (
                          <option
                            key={option.floorcode}
                            value={option.floorcode}
                          >
                            {option.floorname}
                          </option>
                        ))}
                      </select>
                      <hr className="absolute left-0 px-2 bottom-0 w-full h-0.5 border-none bg-gray-500" />
                    </div>
                  </div>

                  {/* Area */}
                  <div className="grid gap-4 m-8 sm:grid-cols-3 grid-cols-3 items-center text-sm">
                    <label
                      htmlFor="area"
                      className="block w-full relative text-sm font-semibold sm:col-span-1 grid-cols-1"
                    >
                      Area:
                    </label>
                    <div className="block w-full relative sm:col-span-2 col-span-2">
                      <input
                        type="text"
                        id="area"
                        name="area"
                        value={formData.area || ""}
                        onChange={handleChange}
                        className="block w-full pl-2 pr-8 py-1.5 border-none shadow-sm bg-gray-100 focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 text-sm"
                        required
                      />
                      <hr className="absolute left-0 px-2 bottom-0 w-full h-0.5 border-none bg-gray-500" />
                    </div>
                  </div>
                  {/* Rate */}
                  <div className="grid gap-4 m-8 sm:grid-cols-3 grid-cols-3 items-center text-sm">
                    <label
                      htmlFor="rate"
                      className="block w-full relative text-sm font-semibold sm:col-span-1 grid-cols-1"
                    >
                      Rate:
                    </label>
                    <p className="block w-full relative sm:col-span-2 col-span-2"></p>
                  </div>
                </div>
                <div className="flex justify-center mt-6">
                  <button
                    className="px-6 py-1.5 m-2 bg-blue-500 text-white rounded-full text-md"
                    // onClick={handleSave}
                  >
                    Save
                  </button>
                  <button
                    className="px-6 py-1.5 m-2 bg-red-500 text-white rounded-full text-md"
                    onClick={handleClose}
                  >
                    Close
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </Dialog>
    </Transition>
  );
};

export default CommercialModal;
